<template >
  <div class="row">
    <div class="col-12">
      <ul class="nav nav-tabs mb-2">
        <li
            v-for="(langItem, langIndex)  in lang"
            class="nav-item"
        >
          <a
              :class="'nav-link' + ((activeTab == langIndex)? ' active':'')"
              @click.prevent="changeTab(langIndex)"
              href="#"
          >
            <country-flag
                :country='langItem.flag'
                size="small"
            />
            {{langItem.title}}

          </a>
        </li>
      </ul>

    </div>
    <div
        :class="'col col-12 col-md-4'"
    >
      <template
          v-for="(langItem, langIndex)  in lang"
      >

        <div
            v-show="activeTab == langIndex"
        >
          <textarea
              v-model="inputModel.question[langIndex]"
              :id="inputObj.name + '_lang_' + langIndex"
              type="text"
              class="form-control"
          >
             </textarea>

        </div>

      </template>

    </div>
    <div
        :class="'col col-12 col-md-8'"
    >
      <template
               v-for="(langItem, langIndex)  in lang"
      >

             <div
                 v-show="activeTab == langIndex"
             >
               <html-editor2
                   v-if="inputObj.params && inputObj.params.is_wysiwig"
                   v-model="inputModel.answer[langIndex]"
                   editor-type="segment_odstavec"
               />
               <textarea
                   v-else
                   v-model="inputModel.answer[langIndex]"
                   :id="inputObj.name + '_lang_' + langIndex"
                   type="text"
                   class="form-control"
               >
             </textarea>

             </div>

           </template>
    </div>
  </div>

<!--
  <display-debug>
    <template #debugView>inputModel {{inputObj}}</template>
  </display-debug>
-->
</template>

<script>
import ImageComponent from "@/components/general/Image";
import htmlEditor2 from "@/components/content/htmlEditor_v2.vue";
import CountryFlag from "vue-country-flag-next"

export default {
  name: "HeroSegment",
  components: {
    CountryFlag,
    htmlEditor2,
    //ImagePreview,
    ImageComponent,
  },
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Number,String, Object],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputModel: {
        question: {},
        answer: {},
      },
      activeTab: null,
    }
  },
  created() {
    if(this.lang) {

      this.inputModel.text = {};
      for (const i in this.lang){
        if(this.activeTab === null) {
          this.activeTab = i;
        }
        this.inputModel.question[i] = null;
        this.inputModel.answer[i] = null;
      }

      if(this.inputObj.obsah) {
        this.createInputModelValues(this.inputObj.obsah)
      }
    }
  },
  mounted() {

/*
    if(this.inputObj.obsah) {
      console.log("dev hero mounted", this.inputObj.obsah)
      this.createInputModelValues(this.inputObj.obsah)
      //this.inputModel = this.inputObj.obsah;
    }
  */
  },
  methods: {
    changeTab(index) {
      this.activeTab = index;
    },
    createInputModelValues(data) {

      for(const i in this.inputModel) {
        if(typeof data[i] !== "undefined") {
          for(const j in this.inputModel[i]) {
            this.inputModel[i][j] = data[i][j];
          }
        }
      }
    }
  },
  watch: {
    inputObj: {
      handler(newVal, oldVal) {
        if(newVal.obsah) {
          this.createInputModelValues(newVal.obsah)
        }
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal, oldVal) {
        if(typeof oldVal != "undefined") {
          this.$emit('update:modelValue', newVal )
        }
      },
      deep: true,
      immediate: true
    },

  },
};
</script>